import React, { useEffect, useState } from "react";
import SvgMap from "./Modules/SvgMap";

import './gardenMap.css'
import ViewBox from "./Modules/ViewBox";
import Service, { BedData } from "./Modules/Service";

export function App(props:{contentId:string}) {
    const service=new Service(props.contentId)

    const [viewState,setViewState]=useState<"View"|"Hidden">("View")
    const [bed,setBed]=useState<string|null>(null)
    const [bedDetails,setBedDetails]=useState<BedData|null>(null)

    useEffect(()=>
    {

        if(bed!=null)
        {
        service.GetBedData(bed,props.contentId).then(data=>
        {
            setBedDetails(data)
        }
        )
    }
        

    },[bed])


    return (
        <>
        {(viewState=="View" && bedDetails!=null)?

        <ViewBox onClose={()=>setViewState("Hidden")}  bedDetails={bedDetails}/>:null}
    <SvgMap onSelectBed={(e)=>
    {setBedDetails(null)
        setBed(e)
        setViewState("View")
    }
    } /></>
        )

  }